import { useLocation } from 'react-router';
import { useRunOnce } from '../common/useRunOnce';
import { useMcpConnectionsApiFacade } from '../../apis/facades/useMcpConnectionsApiFacade';
import type { McpServerType } from '@server/mcp';
import { telemetry } from '../../telemetry';

const McpOAuthRedirect = () => {
  const { search } = useLocation();
  const { handleOAuthCallback } = useMcpConnectionsApiFacade();

  useRunOnce(async () => {
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const serverType = params.get('state') as McpServerType | null;

    if (code && serverType) {
      try {
        await handleOAuthCallback(serverType, code);
      } catch (error) {
        telemetry.captureError(error);
      }
    }
    window.close();
  });

  return null;
};

export { McpOAuthRedirect };
